import { styled } from '@visualfabriq/vf-ui-kit';

export const StepBody = styled('div', () => ({
  display: 'flex',
  flex: '0 1 auto',
  overflowY: 'auto',
}));
